import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from "react-i18next";


const Portfolio = ({slug, thumb, classes, title, category, variant}) => {

    const { t } = useTranslation();

    const handlePortfolioClick = () => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'portfolio_click',
            portfolio_title: title,
            portfolio_category: category,
            portfolio_slug: slug
        });
    };

    return (
        <div className={`portfolio-item ${classes ? classes : ' '}`}>
            <Link
                className={'d-block'}
                to={`/portfolio/${slug}`}
                onClick={handlePortfolioClick}
            >
                {variant === 'column' ? (
                    <div className="portfolio-image">
                        <img src={require('../../assets/images/portfolio/' + thumb)} alt={title}/>
                    </div>

                ) : (
                    <div
                        className="portfolio-image"
                        style={{backgroundImage: `url(${require('../../assets/images/portfolio/' + thumb)})`}}
                    />
                )}
                <div className="portfolio-content">
                    <h4 className="title">{t(title)}</h4>
                    <div className="category"><span>{category}</span></div>
                </div>
            </Link>
        </div>
    );
};

export default Portfolio;